module.exports = __webpack_public_path__ + "img/ClearTampering.927b8dfa.png";